import React, { useEffect, useState } from "react";
import catalogue_image from "../../User/assets/catalogue.svg";
import Cartproduct from "../../User/components/Cart_product";
import Defaultaddress from "../../User/components/Default_address";
import { Button, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
// import Addedaddress from "../../User/components/Added_address";
import order_complete from "../../User/assets/order-successful.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../context/Context";
import User_address from "./User_address";
import CircularProgress from "@mui/material/CircularProgress";


const orderdetails = [
  {
    productName: "Trousers",
    productDescription: "Lorem Ipsum has been the industry's standard.",
    productImage: catalogue_image,
  },
  {
    productName: "Blouses",
    productDescription: "Lorem Ipsum has been the industry's standard.",
    productImage: catalogue_image,
  },
  {
    productName: "Shirts",
    productDescription: "Lorem Ipsum has been the industry's standard.",
    productImage: catalogue_image,
  },
  {
    productName: "Jeans",
    productDescription: "Lorem Ipsum has been the industry's standard.",
    productImage: catalogue_image,
  },
];

const Ordersummary = ({ selectedData }) => {
  const navigate = useNavigate();
  const { SetCartItem } = useGlobalContext()
  // Initialize state for activeStep
  const [currentStep, setCurrentStep] = useState(0); // Manage the active step
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [data, setData] = useState(null);
  const [ordered, setOrdered] = useState(null);
  const steps = ["Your order", "Pickup address", "Order successfully"];
  const [openDialog, setOpenDialog] = useState(false)
  const [searchparams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  // const orderids = searchparams.get("orderids");
  // useEffect(() => {
  //   setCurrentStep(1);
  // }, [orderids]);
  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const [addresses, setAddresses] = useState();

  const getAddressData = async () => {
    try {
      const response = await instance.get("Address/getAddress");
      setAddresses(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getCartData = async () => {
    try {
      const response = await instance.get("/Cart/getCart");
      setData(response?.data?.data?.items);
    } catch (error) {
      console.log(error);
    }
  };
  const handleOrder = async () => {
    try {
      setLoading(true);
      const data = {
        selected_items: selectedData.map((item) => item._id),
        address: selectedAddress?._id,
      };

      const response = await instance.post("/Order/createOrder", data);

      if (response.data.success === true) {
        toast.success(response.data.message);
        setOrdered(true);
        SetCartItem(true);
        navigate('/profile/myorders');

      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAddressData();
    getCartData();
  }, []);

  return (
    <React.Fragment>
      <section className="catalogue-order">

        {ordered === true ? null : (
          <div className="stepper-wrapper">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`stepper-item ${index < currentStep ? "completed" : ""
                  } ${index === currentStep ? "active" : ""}`}
                onClick={() => {
                  // Allow navigation only to current or previous steps
                  if (index <= currentStep) {
                    setCurrentStep(index);
                  }
                }}
                style={{
                  cursor: index <= currentStep ? "pointer" : "not-allowed",
                }} // Pointer only for current or previous steps
              >
                <div className="step-counter"></div>
                <div className="step-name">{step}</div>
              </div>
            ))}
          </div>
        )}
        {/* Dynamic Content for Each Step */}
        <div className="step-content">
          {currentStep === 0 && (
            <div className="catalogue-order">
              {selectedData.map((order, index) => (
                <Cartproduct
                  key={index} // Always provide a unique key when mapping in React
                  data={order}
                  showCheckbox={false} // Pass condition to show checkbox
                  // setSelectedData={setSelectedData}
                  getCartData={getCartData}
                  selectedData={selectedData}
                />
              ))}
              <div className="catalogue-order-btn">
                <Button
                  onClick={() => {
                    setCurrentStep(1);
                  }}
                >
                  Confirm
                </Button>
              </div>
            </div>
          )}
          {currentStep === 1 && (
            <>
              <div className="catalogue-order order-address ">
                <Grid container spacing={3} rowSpacing={3} alignItems="stretch" >
                  {addresses?.length
                    ? addresses.map((data) => (
                      <Grid size={{ sm: 12, xs: 12, md: 6, lg: 4 }} >
                        <Defaultaddress
                          data={data}
                          selectedId={selectedAddress}
                          onSelect={setSelectedAddress}
                          setCurrentStep={setCurrentStep}
                          handleOrder={handleOrder}
                          selectedData={selectedData}
                        />
                      </Grid>)) : null}
                </Grid>

              </div>
              <div className="address">
                <div className="address-btn">
                  <Button onClick={() => setOpenDialog(true)}>
                    Add Address
                  </Button>
                </div>
              </div>
            </>
          )}
          {currentStep === 2 && (
            <div className="catalogue-order">
              <div className="cart-no-items success-wrapper">

                {loading && (
                  <div className="loader-overlay">
                    <CircularProgress size={60} thickness={4} />
                  </div>
                )}

                <img src={order_complete} alt="order_complete" className="success-img" />
                <Typography>Order placed successfully!</Typography>
              </div>
            </div>
          )}

        </div>
      </section>
      <User_address
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        FetchAddress={getAddressData}
      />
    </React.Fragment>
  );
};

export default Ordersummary;
